export const PRIMARY_COLOR = '#0f6d7e';

export const SECONDARY_COLOR = '#8e8e93';

const CUSTOM_HOVER_COLOR_RGB: [number, number, number] = [67, 119, 107];

export const CUSTOM_HOVER_COLOR_STYLE = `rgba(${CUSTOM_HOVER_COLOR_RGB[0]}, ${CUSTOM_HOVER_COLOR_RGB[1]}, ${CUSTOM_HOVER_COLOR_RGB[1]}, 0.2)`;
